import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLenis } from "@studio-freight/react-lenis";

// components
import AccordionItem from "../AccordionItem";
import MainButton from "../MainButton";

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const Accordion = ({ title, items }) => {
  const [visibleItems, setVisibleItems] = useState(6);
  const lenis = useLenis();

  const handleLoadMore = () => {
    setVisibleItems(items.length);
  };

  // When the list expands, force Lenis to recalc heights so scrolling continues
  useEffect(() => {
    if (lenis && typeof lenis.resize === "function") {
      requestAnimationFrame(() => lenis.resize());
    }
  }, [visibleItems, lenis]);

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className={cn("wrapper")} id='servizi'>
      <div className={cn("container")}>
        <div className={cn("title")}>
          <h2>{title}</h2>
        </div>
        <motion.div className={cn("accordions")}>
          <AnimatePresence>
            {items.slice(0, visibleItems).map((item, index) => (
              <motion.div
                className={cn("item")}
                key={index}
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <AccordionItem title={item.title} text={item.text} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
        {visibleItems < items.length && (
          <div className={cn("load-more")}>
            <MainButton
              text="Carica altre attività"
              variant="secondary"
              onClick={handleLoadMore}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Accordion;
